/* RESPONSIBLE TEAM: team-data-foundations */
import Model, { attr } from '@ember-data/model';
import { getIconForMcpServer } from './constants/mcp-templates';
import type SetupAction from './setup-action';
import type Store from '@ember-data/store';

export default class McpServer extends Model {
  @attr('string') declare name: string;
  @attr('string') declare url: string;
  @attr('string') declare description: string;
  @attr('string') declare token_id: string;
  @attr('string') declare token_value: string;
  @attr('string') declare auth_type: string;

  declare store: Store;

  get icon(): string {
    return getIconForMcpServer(this.name);
  }

  get mcpActions(): SetupAction[] {
    return this.store
      .peekAll('workflow-connector/setup-action')
      .filter((action: SetupAction) => action.mcpServerId === this.id);
  }
}
